export var EFieldType;

(function (EFieldType) {
  EFieldType["Integer"] = "integer";
  EFieldType["Float"] = "float";
  EFieldType["Price"] = "price";
  EFieldType["Number"] = "number";
  EFieldType["String"] = "string";
  EFieldType["Masked"] = "masked";
  EFieldType["OneChoice"] = "oneChoice";
  EFieldType["MultiChoice"] = "multiChoice";
  EFieldType["Select"] = "select";
  EFieldType["Checkbox"] = "checkbox";
  EFieldType["Textarea"] = "textArea";
  EFieldType["Date"] = "date";
  EFieldType["RadioGroup"] = "radioGroup";
  EFieldType["RadioButtonGroup"] = "radioButtonGroup";
})(EFieldType || (EFieldType = {}));